/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 4
// module chunks = 4